import { ExternalWarehouseSaturationDTO } from '../dto/ExternalWarehouseSaturationDTO';
import { ExternalWarehouseSaturationData } from '../../domain/ExternalWarehouseSaturationData';

export class ExternalWarehouseSaturationMapper {
  static toDomain(
    dto: ExternalWarehouseSaturationDTO
  ): ExternalWarehouseSaturationData {
    return new ExternalWarehouseSaturationData(
      dto.zone_code,
      dto.current_stock,
      dto.max_capacity,
      dto.available_capacity,
      dto.occupancy_percentage
    );
  }

  static toDomainList(
    dtos: ExternalWarehouseSaturationDTO[]
  ): ExternalWarehouseSaturationData[] {
    return dtos.map(this.toDomain);
  }
}
